<article class="event-overview" [class.no--featured]="!featured$().length">
  <app-header
    [theme]="'secondary'"
    [subTitle]="'agenda-overzicht-subtitel' | fromDictionary: false"
    [title]="'agenda-overzicht-titel' | fromDictionary"
  >
    <!--(filtersChanged)="handleFilterChange($event)"-->
    <app-event-filters
      [filterOptions]="filterOptions"
      [filterValues]="filterInput()"
      [from]="from()"
      [to]="to()"
      #filters
    ></app-event-filters>
  </app-header>

  <!-- featured -->
  @if (!filters.hasFiltersActive$() && featured$().length) {
    <div class="event-overview__featured mb-3">
      <div class="container pt-3 pt-md-4">
        <h2 class="h4 text-accent z-2 position-relative mb-0">{{ 'agenda-overzicht-tips-titel' | fromDictionary }}</h2>
      </div>
      <app-event-card-slider
        class="d-block z-2"
        [events]="featured$()"
        [cookiePreferences]="cookiePreferences$()"
        [maxItems]="3"
        [showNav]="false"
        [showArrow]="true"
        [theme]="'secondary'"
        [priority]="true"
      ></app-event-card-slider>
    </div>
  }

  <!--<pre>{{ filterInput() | json }}</pre>
  <pre>{{ filterValues$() | json }}</pre> -->

  <div class="container pt-3 section-outset-b event-overview__inner">
    <div class="row">
      <!-- in coda -->
      <main class="event-overview__main py-4 py-lg-5" [ngClass]="sidebarItems$().length ? 'col-md-16' : 'col-24'">
        <h3 class="z-2 h4 mb-3 mb-sm-4">{{ 'agenda-overzicht-binnen-coda-titel' | fromDictionary }}</h3>
        <ul class="list-unstyled row gutter-x-3 gutter-y-2 gutter-y-sm-3 z-2" [@CardGridAnimation]="events$().length">
          @for (event of events$(); track event.trackingKey; let i = $index) {
            <li [ngClass]="sidebarItems$().length ? 'col-12' : 'col-sm-12 col-md-8'">
              <app-event-card [theme]="'secondary'" [inList]="true" [event]="event" [priority]="i < 8"></app-event-card>
            </li>
          }

          @if (eventsPage$().resultCount > events$().length) {
            <li class="col-24 text-center mt-4">
              <button
                class="button button--accent"
                (click)="loadMoreEvents()"
                (fstrInViewport)="loadMoreEvents()"
                [threshold]="0.1"
                [once]="false"
              >
                <span>{{ 'agenda-overzicht-toon-meer-knoptekst' | fromDictionary }}</span>

                @if (loading$()) {
                  <app-loading-indicator [loading]="true" [type]="'standalone'"></app-loading-indicator>
                } @else {
                  <fstr-icon anchor="line-icon-arrow-down"></fstr-icon>
                }
              </button>
            </li>
          }

          @if (
            eventsPage$().resultCount > eventsPage$().pageSize && !(eventsPage$().resultCount > events$().length) && events$().length > 0
          ) {
            <!-- reached end -->
            <article class="text-center py-6">
              <fstr-icon class="text-secondary icon-lg mb-2 d-block" anchor="line-icon-smile"></fstr-icon>

              <div class="text-max-width-xs mx-auto">
                <h1 class="h4 text-secondary">{{ 'agenda-overzicht-einde-bereikt-titel' | fromDictionary }}</h1>
                <p class="fs-body-md">{{ 'agenda-overzicht-einde-bereikt-tekst' | fromDictionary }}</p>
              </div>

              <div class="d-flex flex-wrap gap-2 justify-content-center mt-4">
                <a class="button button--secondary" href="">
                  <span>Plan bezoek</span>
                </a>

                <a class="button button--secondary-subtle" href="">
                  <span>Museum tickets</span>
                </a>
              </div>
            </article>
          }

          <!-- Empty state after filtering -->
          @if (events$().length === 0) {
            <article class="text-center py-6">
              <div class="text-max-width-xs mx-auto">
                <h1 class="h4 text-secondary">{{ 'agenda-overzicht-geen-resultaten-titel' | fromDictionary }}</h1>
                <p class="fs-body-md">{{ 'agenda-overzicht-geen-resultaten-tekst' | fromDictionary }}</p>
              </div>

              <div class="d-flex flex-wrap gap-2 justify-content-center mt-4">
                <a class="button button--secondary" [routerLink]="['/plan-je-bezoek']">
                  <span>Plan bezoek</span>
                </a>

                <a class="button button--secondary-subtle" [routerLink]="['/agenda']">
                  <span>Reset filters</span>
                </a>
              </div>
            </article>
          }
        </ul>
      </main>

      <!--@if (sidebarItems$().length) {
        <aside class="offset-1 col-md-7 event-overview__aside py-4 py-lg-5">
          // CTA cards

          <h3 class="z-2 h4 mb-2">Cultuurhuis</h3>

          <h4 class="text-secondary h6 mb-3">Beleef het buiten!</h4>
          <ul class="list-unstyled">
            @for (event of events$(); track event.id; let i = $index) {
              <li class="">
                <app-event-card [inList]="true" [event]="event" [priority]="i < 4"></app-event-card>
              </li>
            }
          </ul>

          <h4 class="text-secondary h6 mb-3 mt-4">Activiteiten voor thuis</h4>
          <ul class="list-unstyled">
            @for (event of events$(); track event.id) {
              <li class="">
                <app-event-card [inList]="true" [event]="event"></app-event-card>
              </li>
            }
          </ul>
        </aside>
      }-->
    </div>
  </div>

  <!--<app-pagination [page]="eventsPage$()"></app-pagination>-->
</article>
